// src/pages/Meijimura/CouponInfo.js
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../styles/CouponInfo.css";

// ★ 次の画面へのパス（実際のルーティングに合わせて変更してください）
const NEXT_PATH = "/meijimura/guide";

export default function CouponInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(NEXT_PATH);
  };

  return (
    <div className="coupon-info">
      <div className="coupon-info__inner">
        <h1 className="coupon-info__title">
          <span className="coupon-info__bracket" aria-hidden="true">＼</span>
          <span className="coupon-info__highlight">
            {t('Coupon available')}
          </span>
          <span className="coupon-info__bracket" aria-hidden="true">／</span>
        </h1>

        <p className="coupon-info__subtitle">
          {t('Answer the survey after your visit to get a coupon!')}
        </p>

        <div className="coupon-info__ticket">
          <img
            src="/images/coupon.svg"
            alt=""
            className="coupon-info__ticket-img"
          />
        </div>

        <p className="coupon-info__note">
          {t('Limited to one per visit, valid on purchases of ¥1,000 or more.')}
        </p>

        <div className="coupon-info__description">
          <p>
            {t('When you are finished, please press the End Guide button.')}
          </p>
          <p>
            <span className="coupon-info__highlight coupon-info__highlight--block">
              {t('Answer the survey afterward to receive a coupon usable at the Museum Shop or the SL Tokyo Station kiosk.')}
            </span>
          </p>
        </div>

        <button
          type="button"
          className="coupon-info__button"
          onClick={handleNext}
        >
          {t('Go to next screen')}
        </button>
      </div>
    </div>
  );
}